import {
  extendBooking,
  getBookings,
} from "../../../../Redux/Bookings/BookingsActions";
import { AppDispatch, RootState } from "../../../../Redux/store";
import toastHelper from "../../../../Util/toastHelper";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import validator from "../../../../Util/validator";
import React, { useEffect, useState } from "react";
import styles from "./ExtendBooking.module.scss";
import Modal from "../../../Common/Modal/Modal";
import moment from "moment";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedBooking: any;
}

function ExtendBooking(props: Props) {
  const { isOpen, setIsOpen, selectedBooking } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { extendBookingLoading } = useSelector(
    (state: RootState) => state.bookings,
  );
  const [errors, setErrors] = useState<{
    extendTime: string;
    extendDate: string;
  }>({
    extendTime: "",
    extendDate: "",
  });
  const [extendDate, setExtendDate] = useState<string>(
    moment(selectedBooking?.endTime).format("YYYY-MM-DD"),
  );
  const [extendTime, setExtendTime] = useState<string>(
    moment(selectedBooking?.endTime).format("HH:mm"),
  );

  const extendBookingHandler = () => {
    if (selectedBooking?.rateType === "Per Hour") {
      const { errors: fieldErrors, isValid } = validator([
        {
          key: "extendTime",
          type: "text",
          value: extendTime,
        },
      ]);
      setErrors({ ...errors, ...fieldErrors });
      if (isValid && !extendBookingLoading) {
        const successHandler = () => {
          setIsOpen(false);
          dispatch(getBookings());
        };

        dispatch(
          extendBooking({
            bookingId: selectedBooking?.bookingId,
            endTime: moment(
              `${moment(selectedBooking?.endTime).format("YYYY-MM-DD")} ${extendTime}`,
              "YYYY-MM-DD HH:mm",
            ).format("YYYY-MM-DDTHH:mm:ss"),
            successHandler,
          }),
        );
      }
    }

    if (selectedBooking?.rateType === "Per Day") {
      const { errors: fieldErrors, isValid } = validator([
        {
          key: "extendDate",
          type: "date",
          value: extendDate,
        },
      ]);
      setErrors({ ...errors, ...fieldErrors });
      if (isValid && !extendBookingLoading) {
        const successHandler = () => {
          setIsOpen(false);
          dispatch(getBookings());
        };
        dispatch(
          extendBooking({
            bookingId: selectedBooking?.bookingId,
            endTime: moment(`${extendDate} 23:59`, "YYYY-MM-DD HH:mm").format(
              "YYYY-MM-DDTHH:mm:ss",
            ),
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    setExtendDate(
      moment(selectedBooking?.endTime).add(1, "day").format("YYYY-MM-DD"),
    );
    setExtendTime(
      moment(selectedBooking?.endTime).add(1, "hour").format("HH:mm"),
    );
    setErrors({
      extendTime: "",
      extendDate: "",
    });
  }, [selectedBooking]);

  return (
    <React.Fragment>
      {extendBookingLoading && <Loading />}
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} showCloseIcon={true}>
        <div className={styles.mainContainer}>
          <div className={styles.headingContainer}>
            <p className={styles.label}>Extend Booking</p>
          </div>
          <div className={styles.contentContainer}>
            <div className={styles.contentInnerContainer}>
              {selectedBooking?.rateType === "Per Hour" && (
                <>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Start Time</p>
                    <input
                      type="time"
                      className={styles.input}
                      defaultValue={moment(selectedBooking?.startTime).format(
                        "HH:mm",
                      )}
                      disabled
                    />
                  </div>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>End Time</p>
                    <input
                      type="time"
                      className={styles.input}
                      defaultValue={moment(selectedBooking?.endTime).format(
                        "HH:mm",
                      )}
                      disabled
                    />
                  </div>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Extend Time</p>
                    <select
                      className={styles.input}
                      value={extendTime}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          moment(value).isBefore(
                            moment(selectedBooking?.endTime).format("HH:mm"),
                          )
                        ) {
                          toastHelper.error(
                            "Extend time must be after end time",
                          );
                        } else {
                          setExtendTime(value);
                        }
                      }}
                    >
                      {!extendTime && <option value="">Select Time</option>}
                      {Array.from({ length: 48 }, (_, i) => {
                        const hour24 = Math.floor(i / 2);
                        const minute = (i % 2) * 30;

                        const timeString24Hr = `${hour24.toString().padStart(2, "0")}:${minute
                          .toString()
                          .padStart(2, "0")}`;

                        if (
                          timeString24Hr <=
                          moment(selectedBooking?.endTime).format("HH:mm")
                        )
                          return null;

                        let hour12 = hour24 % 12;
                        if (hour12 === 0) hour12 = 12;

                        const period = hour24 < 12 ? "AM" : "PM";

                        const timeString12Hr = `${hour12.toString().padStart(2, "0")}:${minute
                          .toString()
                          .padStart(2, "0")} ${period}`;

                        return (
                          <option key={timeString24Hr} value={timeString24Hr}>
                            {timeString12Hr}
                          </option>
                        );
                      })}
                    </select>
                    <p className={styles.error}>{errors.extendTime}</p>
                  </div>
                </>
              )}
              {selectedBooking?.rateType === "Per Day" && (
                <>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Start Date</p>
                    <input
                      type="date"
                      className={styles.input}
                      value={moment(selectedBooking?.startTime).format(
                        "YYYY-MM-DD",
                      )}
                      disabled
                    />
                  </div>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>End Date</p>
                    <input
                      type="date"
                      className={styles.input}
                      value={moment(selectedBooking?.endTime).format(
                        "YYYY-MM-DD",
                      )}
                      disabled
                    />
                  </div>
                  <div className={styles.inputContainer}>
                    <p className={styles.label}>Extend Date</p>
                    <input
                      type="date"
                      className={styles.input}
                      value={extendDate}
                      onChange={(e) => {
                        if (
                          moment(e.target.value).isBefore(
                            moment(selectedBooking?.endTime).format(
                              "YYYY-MM-DD",
                            ),
                          )
                        ) {
                          toastHelper.error(
                            "Extend date must be after start date",
                          );
                        } else {
                          setExtendDate(e.target.value);
                        }
                      }}
                    />
                    <p className={styles.error}>{errors.extendDate}</p>
                  </div>
                </>
              )}
            </div>
            <div className={styles.buttonContainer}>
              <button className={styles.button} onClick={extendBookingHandler}>
                Update
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default ExtendBooking;
